// extracted by css-extract-rspack-plugin
export default {"branchName":"ClosedOrMergedStateMergeBox-module__branchName__d9J9ihl"};